import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'icc-head-upload',
  templateUrl: './icc-head-upload.component.html',
  styleUrls: ['./icc-head-upload.component.less'],
})
export class IccHeadUploadComponent implements OnInit {
  // 点击上传返回的事件
  @Output() upload: EventEmitter<any> = new EventEmitter<any>();
  // 初始头像
  @Input() headerImg: string;
  // 显隐窗口
  isVisible = false;
  // 窗口中是否选择了图片
  hasImage: boolean;
  // 图片名称
  imgName: string;

  // 图片放置之后的真实宽高，对于裁剪圆动作过程中限制其范围时有用
  limitWidth = 0;
  limitHeight = 0;

  // 鼠标的起始（点击）位置
  mouseX = 0;
  mouseY = 0;
  // dom元素的起始位置
  targetX = 0;
  targetY = 0;
  // true为可以改变裁剪圆位置
  isMouseDown: boolean;
  // 最小圆半径为15
  minRadius = 15;
  // true为可以改变裁剪圆大小
  isOnResize: boolean;

  constructor() {}

  ngOnInit() {}

  /*
   * 显隐头像处理窗口
   */
  displayModal(isShow) {
    if (typeof isShow === 'boolean') {
      this.isVisible = isShow;
    }
  }

  /*
   * 打开图片选择框
   */
  openFile() {
    $('#open_input_file_id').click();
  }

  /*
   * 选中图片确定后触发
   */
  selectImage(evt) {
    const files = evt.target.files;
    if (!files || !files.length) {
      return false;
    }
    let errMsg = '';
    if (files[0].size / 1.0 / 1024 / 1024 > 1) {
      errMsg = '图片大小不能超过1M';
      alert(errMsg);
      return false;
    }
    this.imgName = files[0].name;
    // 读取图片的数据
    const reader = new FileReader();
    reader.onload = evt => {
      // 加载图片获取图片真实宽度和高度
      const img = new Image();
      const fileReader: any = evt.target;
      img.onload = () => {
        if (img.width <= 50) {
          errMsg = '图片宽度必须大于50';
        }
        if (img.height <= 50) {
          errMsg = errMsg ? '图片的宽高必须大于50' : '图片高度必须大于50';
        }
        if (errMsg) {
          alert(errMsg);
          return false;
        }
        if (fileReader.result) {
          this.hasImage = true;
          setTimeout(() => {
            this.displayImage(fileReader.result, img.width, img.height);
          }, 100);
        } else {
          this.hasImage = false;
        }
      };
      img.src = fileReader.result;
    };
    reader.readAsDataURL(files[0]);
  }

  /*
   * 根据上传的图片调整样式
   */
  displayImage(imgUrl, imgWidth, imgHeight) {
    const $imgs = $('.selected_img');
    const $mask = $('#mask_id');
    const $circle = $('#dynamic_circle_box_id');
    // 根据图片真实宽高调整图片、遮罩和裁剪圆的样式
    let width = 0; // 图片实际显示宽
    let height = 0; // 图片实际显示高
    const ratio = (imgWidth * 1.0) / imgHeight;
    if (imgWidth > imgHeight) {
      width = imgWidth > 360 ? 360 : imgWidth;
      height = width / ratio;
    } else if (imgWidth < imgHeight) {
      height = imgHeight > 360 ? 360 : imgHeight;
      width = height * ratio;
    } else {
      width = 360;
      height = 360;
    }
    $imgs.attr('src', imgUrl);
    $imgs.css({
      width: width >= height ? width + 'px' : 'auto',
      height: height >= width ? height + 'px' : 'auto',
      left: 0,
      top: 0,
    });
    $mask.css({
      width: width >= height ? width + 'px' : '100%',
      height: height >= width ? height + 'px' : '100%',
    });
    // 重置截取圆的位置，并取最小值最为宽高
    const minLength = width > height ? height : width;
    $circle.css({
      width: minLength + 'px',
      height: minLength + 'px',
      left: 0,
      top: 0,
    });
    this.limitWidth = width;
    this.limitHeight = height;
    this.previewImage();
  }

  /*
   * 根据当前图片的选中区域预览裁剪部分
   */
  previewImage() {
    const $dynamicCircle = $('#dynamic_circle_box_id')[0];
    const $sourceImg = $('#dynamic_image_id')[0];
    const ratio = $sourceImg.naturalHeight / $sourceImg.clientHeight; // 图片的原始高度/放置的高度
    const clip_offsetLeft = $dynamicCircle.offsetLeft * ratio;
    const clip_offsetTop = $dynamicCircle.offsetTop * ratio;
    const clip_width = $dynamicCircle.clientWidth * ratio;
    const clip_height = $dynamicCircle.clientHeight * ratio;

    $('#canvas_100_id')[0]
      .getContext('2d')
      .drawImage($sourceImg, clip_offsetLeft, clip_offsetTop, clip_width, clip_height, 0, 0, 100, 100);
    $('#canvas_50_id')[0]
      .getContext('2d')
      .drawImage($sourceImg, clip_offsetLeft, clip_offsetTop, clip_width, clip_height, 0, 0, 50, 50);
  }

  /*
   * 裁剪合适尺寸的图片放到相应大小的canvas上，否则100*100的裁剪区域放到150*150的区域上会出现模糊现象
   */
  uploadImage() {
    const $dynamicCircle = $('#dynamic_circle_box_id')[0];
    const $sourceImg = $('#dynamic_image_id')[0];
    const ratio = $sourceImg.naturalHeight / $sourceImg.clientHeight;
    const dest_dynamic = document.createElement('canvas');
    dest_dynamic.width = $dynamicCircle.clientWidth;
    dest_dynamic.height = $dynamicCircle.clientHeight;
    dest_dynamic
      .getContext('2d')
      .drawImage(
        $sourceImg,
        $dynamicCircle.offsetLeft * ratio,
        $dynamicCircle.offsetTop * ratio,
        $dynamicCircle.clientWidth * ratio,
        $dynamicCircle.clientHeight * ratio,
        0,
        0,
        $dynamicCircle.clientWidth,
        $dynamicCircle.clientHeight,
      );
    // 给页面设置展示头像
    const $headPhoto = $('#header_photo_id');
    $headPhoto.attr('src', dest_dynamic.toDataURL('image/png'));
    $headPhoto.css('display', 'block');

    this.displayModal(false);

    // base64格式图片转成FormData对象
    let base64String = dest_dynamic.toDataURL();
    // 这里对base64串进行操作，去掉url头，并转换为byte
    const bytes = window.atob(base64String.split(',')[1]);
    const array = [];
    for (let i = 0; i < bytes.length; i++) {
      array.push(bytes.charCodeAt(i));
    }
    const blob = new Blob([new Uint8Array(array)], { type: 'image/jpeg' });
    const fd = new FormData();
    fd.append('file', blob, this.imgName.slice(0, this.imgName.lastIndexOf('.')) + '.png');
    this.headerImg = null;
    this.upload.emit(fd);
  }

  /*---------------下为裁剪image相关------------------*/

  /*
   * 裁剪圆上按下事件，开始拖拽改变位置
   */
  mouseDown(evt) {
    if (!this.isOnResize) {
      const el = evt.currentTarget;
      this.targetX = this.getNumberFormPixel(el.style.left);
      this.targetY = this.getNumberFormPixel(el.style.top);
      this.mouseX = evt.screenX;
      this.mouseY = evt.screenY;
      this.isMouseDown = true;
    }
    evt.preventDefault();
    return false;
  }
  /*
   * 图片框上的移动事件，可以触发裁剪圆的拖拽和缩放动作
   */
  mouseMove(evt) {
    if (!this.isMouseDown && !this.isOnResize) {
      return false;
    }
    if (this.isMouseDown) {
      this.moveCircle(evt);
    }
    if (this.isOnResize) {
      this.resizeCircle(evt);
    }
    this.previewImage();
  }
  /*
   * 图片框上的抬起事件，表示动作结束
   */
  mouseUp() {
    this.isMouseDown = false;
    this.isOnResize = false;
  }

  /*
   * 将像素改变为数字
   */
  getNumberFormPixel(pixel) {
    let result = 0;
    if (typeof pixel !== 'string' || pixel.lastIndexOf('px') < 2) {
      return result;
    }
    result = Number(pixel.slice(0, pixel.length - 2));
    return typeof result === 'number' ? result : 0;
  }

  /*
   * 缩放圆上的按下事件，表示开始缩放裁剪圆
   */
  resize_mouseDown(evt) {
    this.mouseX = evt.screenX;
    this.mouseY = evt.screenY;
    this.isOnResize = true;
    this.isMouseDown = false;
    evt.preventDefault();
    return false;
  }

  /*移动裁剪圆位置*/
  moveCircle(evt) {
    const $dynamicCircle = $('#dynamic_circle_box_id');
    let offsetX = evt.screenX - this.mouseX;
    let offsetY = evt.screenY - this.mouseY;
    /*上边界*/
    if (this.targetY + offsetY < 0) {
      offsetY = -this.targetY;
    }
    /*右边界*/
    if ($dynamicCircle[0].clientWidth + this.targetX + offsetX > this.limitWidth) {
      offsetX = this.limitWidth - ($dynamicCircle[0].clientWidth + this.targetX);
    }
    /*下边界*/
    if ($dynamicCircle[0].clientHeight + this.targetY + offsetY > this.limitHeight) {
      offsetY = this.limitHeight - ($dynamicCircle[0].clientHeight + this.targetY);
    }
    /*左边界*/
    if (this.targetX + offsetX < 0) {
      offsetX = -this.targetX;
    }

    $dynamicCircle.css({
      left: this.targetX + offsetX + 'px',
      top: this.targetY + offsetY + 'px',
    });
    $('#dynamic_image_id').css({
      left: -(this.targetX + offsetX) + 'px',
      top: -(this.targetY + offsetY) + 'px',
    });
  }
  /*改变裁剪圆大小*/
  resizeCircle(evt) {
    const circleEl = $('#dynamic_circle_box_id')[0];
    const maskEl = $('#mask_id')[0];
    const offsetX = evt.screenX - this.mouseX;
    const offsetY = evt.screenY - this.mouseY;
    let offsetRadius = 0;

    this.mouseX = evt.screenX;
    this.mouseY = evt.screenY;

    // 计算增加或减少的半径
    switch (true) {
      case offsetX > 0 && offsetY > 0:
        offsetRadius = Math.max(offsetX, offsetY);
        break;
      case offsetX < 0 && offsetY < 0:
        offsetRadius = Math.min(offsetX, offsetY);
        break;
      case offsetX > 0 && offsetY < 0:
        offsetRadius = Math.min(offsetX, offsetY);
        break;
      case offsetX < 0 && offsetY > 0:
        offsetRadius = Math.max(offsetX, offsetY);
        break;
      default:
        break;
    }
    // 最小圆半径控制
    if (offsetRadius < 0 && circleEl.clientWidth + offsetRadius < this.minRadius) {
      circleEl.style.width = this.minRadius + 'px';
      circleEl.style.height = this.minRadius + 'px';
      return true;
    }
    // 边界处理
    if (
      circleEl.offsetLeft + circleEl.clientWidth + offsetRadius <= maskEl.clientWidth &&
      circleEl.offsetTop + circleEl.clientHeight + offsetRadius <= maskEl.clientHeight
    ) {
      circleEl.style.width = circleEl.clientWidth + offsetRadius + 'px';
      circleEl.style.height = circleEl.clientHeight + offsetRadius + 'px';
    } else if (circleEl.offsetLeft + circleEl.clientWidth + offsetRadius > maskEl.clientWidth) {
      circleEl.style.width = maskEl.clientWidth - circleEl.offsetLeft + 'px';
    } else if (circleEl.offsetTop + circleEl.clientHeight + offsetRadius > maskEl.clientHeight) {
      circleEl.style.height = maskEl.clientHeight - circleEl.offsetTop + 'px';
    }
  }
}
